import { eagleScoutApplicationModuleSel as moduleSel } from '../../common';

export const visibleSel = state => moduleSel(state).visible;
export const youthNameSel = state => moduleSel(state).youthName;
export const userIdSel = state => moduleSel(state).userId;
